/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { getNotificationTypes } from '../../../../apis/notification';
import { isEmpty } from '../../../../utils/lodashExtend';
import useForm from '../../../../hooks/useForm';
import Form from '../../../../components/Form';
import { chunk } from 'lodash';
import { addThirdPartyMessnger, editThirdPartyMessnger, getThirdPartyMessnger } from '../../../../apis/thirdPartyMesseger';
import { toast } from '../../../../utils/toast';

const defaultForm = {
  appKey: "",
  type: "slack",
  channels: [],
};
const ThirdPartyMesseger = () => {
  const [typeList, setTypeList] = useState([]);
  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState('create');

  const _submit = (form) => {
    if (mode === "create") {
      addThirdPartyMessnger(getParams(form))
        .then(res => {
          toast.success("등록이 완료되었습니다.");
          getData();
        });
    } else {
      editThirdPartyMessnger(form.idx, getParams(form))
        .then(res => {
          toast.success("수정이 완료되었습니다.");
          getData();
        });
    }

  };

  const {
    form,
    errors,
    setForm,
    handleOnChange,
    handleSubmit,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit,
  );


  const getParams = (form) => {
    return {
      type: form.type,
      appKey: form.appKey,
      channels: typeList.map(item => {
        return {
          key: item.key,
          value: form[item.key] || "",
        };
      })
    };
  };


  const getData = () => {
    getThirdPartyMessnger().then(res => {
      const { thirdPartyMessenger } = res;
      if (!isEmpty(thirdPartyMessenger)) {

        const _form = {
          ...thirdPartyMessenger,
        };

        (thirdPartyMessenger.channels || []).forEach(({ key, value }) => {
          _form[key] = value;
        });

        setForm(_form);
        setOriginForm(_form);
        setMode('modify');
      } else {
        setOriginForm(defaultForm);
        setForm(defaultForm);
      }
    });
  };

  useEffect(() => {
    getNotificationTypes().then(res => {
      setTypeList(res);
    });
    getData();
  }, []);

  useEffect(() => {
    if (!isEmpty(typeList)) {
      const _fields = [
        { title: "슬랙 토큰 설정", type: "title" },
        {
          title: "슬랙 TOKEN",
          type: "input",
          key: "appKey",
        },
        {
          type: "title",
          title: "슬랙 채널 설정",
        },
        {
          type: "badge-section-title",
          title: "노출될 채널의 ID 를 입력해주세요.\n 공란일경우 해당 알람은 발송되지 않습니다.",
        },
        ...chunk(typeList, 2).map(fields => {
          return fields.map(({ label, key }) => {
            return {
              title: label,
              key,
              type: "input",
            };
          }
          );
        })
      ];

      setFields(_fields);
    }
  }, [typeList]);

  return (
    <>
      <Form
        form={form}
        errors={errors}
        isRequiredShow={true}
        setForm={setForm}
        fields={fields}
        onChange={handleOnChange}
        submitText={"설정"}
        submit={handleSubmit}
      />
    </>
  );
};

export default ThirdPartyMesseger;